import { useSelector } from 'react-redux';

import { AppState } from '../../../../../../app.types';
import { UserType } from '../../../../../user-profile/user-profile.types';

export function useSelectorUserProfile () {
    return useSelector<AppState, UserType | null>((state: AppState) => {
        return state.userProfiles.data?.user || null;
    });
}
